import React from 'react';

import { Heading, Portfolio } from '../../../components';



const PortfolioSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'our portfolio'} subTitle={'Our Dream Weddings'} />

      {/* Portfolio Section */}
      <Portfolio />

    </section>

  );
}

export default PortfolioSection;